import React from "react";
import { Box, Button } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import { CLIENT_SEGMENT_OPTIONS } from "../../Utils/fundsPeriodTotals";

const dropdownSx = {
  width: { xs: "100%", sm: 190 },
  height: "46px",
  minWidth: 160,
  background: "#111",
  color: "#fff",
  border: "1px solid rgba(255, 255, 255, 0.18)",
  borderRadius: "8px",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-icon": {
    color: "#fff",
  },
  "&:hover": {
    borderColor: "rgba(42, 245, 152, 0.55)",
  },
};

const FundsTableFilterActions = ({
  statusList,
  statusValue,
  onStatusChange,
  statusPlaceholder,
  clientSegment,
  onClientSegmentChange,
  onResetFilters,
  filtersActive = false,
  showStatusFilter = true,
}) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 1.25,
      justifyContent: { xs: "stretch", sm: "flex-start" },
      alignItems: "center",
      width: "100%",
    }}
  >
    <CustomDropDown
      sx={dropdownSx}
      placeholder="Client type"
      menuList={CLIENT_SEGMENT_OPTIONS}
      value={clientSegment}
      onChange={(e) => onClientSegmentChange(e.target.value === "" ? null : e.target.value)}
    />
    {showStatusFilter ? (
      <CustomDropDown
        sx={{ ...dropdownSx, width: { xs: "100%", sm: 220 } }}
        placeholder={statusPlaceholder}
        menuList={statusList}
        value={statusValue}
        onChange={onStatusChange}
      />
    ) : null}
    <Button
      variant="outlined"
      size="small"
      startIcon={<RestartAltIcon sx={{ fontSize: 18 }} />}
      onClick={onResetFilters}
      disabled={!filtersActive}
      sx={{
        height: 46,
        px: 2,
        fontSize: 14,
        fontWeight: 600,
        whiteSpace: "nowrap",
        borderColor: "rgba(42, 245, 152, 0.35)",
        color: "#fff",
        bgcolor: "rgba(42, 245, 152, 0.04)",
        "&:hover": {
          borderColor: "#2af598",
          backgroundColor: "rgba(42, 245, 152, 0.1)",
        },
        "&.Mui-disabled": {
          borderColor: "rgba(255, 255, 255, 0.12)",
          color: "rgba(255, 255, 255, 0.35)",
        },
      }}
    >
      Reset filters
    </Button>
  </Box>
);

export default FundsTableFilterActions;
